import React from 'react';
import PopUp from '../../GeneralComponents/PopUp';

const FillLocaleStoragePopUp = (props) => {

    const {
        openAlert,
        setOpenAlert
    } = props;

    const handleCancel = () => {
        setOpenAlert(false);
    }

    return (
          <PopUp
            openAlert={openAlert}
            setOpenAlert={setOpenAlert}
            handleConfirm={handleCancel}
            title="Maximum page capacity reached"
            insideDescription="Please reduce the size of your images as you have reached the total maximum allowed."
            confirmText='Ok'
          />
      );


} 

export default FillLocaleStoragePopUp;